// // // // import React from 'react';
// // // // import { Outlet, useNavigate } from 'react-router-dom';
// // // // import { useState } from 'react';
// // // // import { faHandPaper } from '@fortawesome/free-solid-svg-icons'; 
// // // // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// // // // import animationData from '../../../src/animations/search.json';
// // // // import Lottie from 'react-lottie';
// // // // import { useSelector } from 'react-redux';
// // // // import 'bootstrap/dist/css/bootstrap.min.css';
// // // // import './Home.css'

// // // // const text = 'Project Hub';

// // // // const LetterRotator = () => {
// // // //   return (
// // // //     <div className="d-flex justify-content-center mb-3" style={{ fontSize: '8vh', fontWeight: 'bold' }}>
// // // //       {text.split('').map((letter, index) => (
// // // //         <span key={index} className="mx-1">{letter}</span>
// // // //       ))}
// // // //     </div>
// // // //   );
// // // // };

// // // // function Home() {
// // // //   const [isHovered, setIsHovered] = useState(false);
// // // //   const [searchQuery, setSearchQuery] = useState('');
// // // //   const navigate = useNavigate();
// // // //   const defaultOptions = {
// // // //     loop: true,
// // // //     autoplay: true,
// // // //     animationData: animationData,
// // // //     rendererSettings: {
// // // //       preserveAspectRatio: 'xMidYMid slice',
// // // //     },
// // // //   };

// // // //   const user = useSelector((state) => state.User.currentUser);
// // // //   const login = !!user;

// // // //   const handleSearchChange = (event) => {
// // // //     setSearchQuery(event.target.value);
// // // //   };

// // // //   const handleSearchSubmit = (event) => {
// // // //     event.preventDefault();
// // // //     navigate(`/projects?query=${encodeURIComponent(searchQuery)}`);
// // // //   };

// // // //   return (
// // // //     <div className="container-fluid min-vh-100 d-flex flex-column justify-content-center align-items-center bg-light text-center" style={{ background: 'linear-gradient(155deg, #ffffff 50%, #ebecff 50%)' }}>
// // // //       <div className="position-relative w-100">
// // // //         {login && user?.name && (
// // // //           <div className="position-absolute top-0 end-0 p-3">
// // // //             <div className="bg-warning text-dark rounded px-3 py-1">
// // // //               <FontAwesomeIcon icon={faHandPaper} className="me-2" />Hi, {user.name}
// // // //             </div>
// // // //           </div>
// // // //         )}

// // // //         <div className="mt-5">
// // // //           <Outlet />
// // // //           <h6 className="text-muted">VNRVJIET</h6>
// // // //         </div>

// // // //         <LetterRotator />

// // // //         <p className="lead">Find, Learn, and Inspire with College Projects</p>

// // // //         <form className="w-75 mx-auto d-flex flex-column flex-sm-row align-items-center gap-2" onSubmit={handleSearchSubmit}>
// // // //           <input
// // // //             className="form-control"
// // // //             type="search"
// // // //             placeholder="Search..."
// // // //             aria-label="Search"
// // // //             value={searchQuery}
// // // //             onChange={handleSearchChange}
// // // //           />

// // // //           <button
// // // //             className={`btn ${isHovered ? 'btn-light text-success' : 'btn-success text-white'} d-flex align-items-center justify-content-center`}
// // // //             type="submit"
// // // //             onMouseEnter={() => setIsHovered(true)}
// // // //             onMouseLeave={() => setIsHovered(false)}
// // // //             style={{ width: '150px', height: '50px', overflow: 'hidden' }}
// // // //           >
// // // //             {!isHovered ? (
// // // //               <span>Search</span>
// // // //             ) : (
// // // //               <Lottie options={defaultOptions} height={50} width={100} />
// // // //             )}
// // // //           </button>
// // // //         </form>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // import React, { useState, useEffect } from 'react';
// // // import { Outlet, useNavigate } from 'react-router-dom';
// // // import { faHandPaper } from '@fortawesome/free-solid-svg-icons'; 
// // // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// // // import animationData from '../../../src/animations/search.json';
// // // import Lottie from 'react-lottie';
// // // import { useSelector } from 'react-redux';
// // // import 'bootstrap/dist/css/bootstrap.min.css';
// // // // import './Home.css';

// // // const text = 'Project Hub';

// // // const LetterRotator = () => {
// // //   return (
// // //     <div className="textr d-flex flex-wrap justify-content-center mb-3" style={{ fontSize: '7vw', fontWeight: 'bold', color: '#1C1F4C' }}>
// // //       {text.split('').map((letter, index) => (
// // //         <span key={index} className="mx-0">{letter}</span>
// // //       ))}
// // //     </div>
// // //   );
// // // };

// // // function Home() {
// // //   const [isHovered, setIsHovered] = useState(false);
// // //   const [searchQuery, setSearchQuery] = useState('');
// // //   const [showGreeting, setShowGreeting] = useState(true);
// // //   const [greetingAnimation, setGreetingAnimation] = useState('slideIn');
// // //   const navigate = useNavigate();
// // //   const defaultOptions = {
// // //     loop: true,
// // //     autoplay: true,
// // //     animationData: animationData,
// // //     rendererSettings: {
// // //       preserveAspectRatio: 'xMidYMid slice',
// // //     },
// // //   };

// // //   const user = useSelector((state) => state.User.currentUser);
// // //   const login = !!user;

// // //   useEffect(() => {
// // //     const timer = setTimeout(() => {
// // //       setGreetingAnimation('slideOut'); // Start sliding out after 1 second
// // //     }, 1000);

// // //     const hideTimer = setTimeout(() => {
// // //       setShowGreeting(false); // Hide the greeting completely after 2 seconds
// // //     }, 2000);

// // //     return () => {
// // //       clearTimeout(timer);
// // //       clearTimeout(hideTimer);
// // //     };
// // //   }, []);

// // //   const handleSearchChange = (event) => {
// // //     setSearchQuery(event.target.value);
// // //   };

// // //   const handleSearchSubmit = (event) => {
// // //     event.preventDefault();
// // //     navigate(`/projects?query=${encodeURIComponent(searchQuery)}`);
// // //   };

// // //   return (
// // //     <div className="container-fluid min-vh-100 d-flex flex-column justify-content-center align-items-center bg-light text-center px-3" 
// // //          style={{ background: 'linear-gradient(155deg,rgb(235, 231, 197) 50%, #EBECFF 40%)' }}>
         
// // //       <div className="position-relative w-100">
// // //         {login && user?.name && showGreeting && (
// // //           <div className="position-fixed end-0 p-3" style={{ top: '70px', zIndex: 1050, animation: `${greetingAnimation} 1s ease-in-out` }}>
// // //             <div className="bg-warning text-dark rounded px-3 py-1 shadow">
// // //               <FontAwesomeIcon icon={faHandPaper} className="me-2" />
// // //               Hi, {user.name}
// // //             </div>
// // //           </div>
// // //         )}

// // //         <div className="mt-5">
// // //           <Outlet />
// // //           <h6 className="text-college" style={{ fontWeight: '600', color: '#037272' }}>VNRVJIET</h6>
// // //         </div>

// // //         <LetterRotator />

// // //         <p className="lead" style={{ fontWeight: '600', color: '#037272' }}>Find, Learn, and Inspire with College Projects</p>

// // //         <form 
// // //           className="w-50 w-sm-75 mx-auto d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 px-2" 
// // //           onSubmit={handleSearchSubmit}
// // //         >
// // //           <input
// // //             className="form-control flex-grow-1"
// // //             type="search"
// // //             placeholder="Search..."
// // //             aria-label="Search"
// // //             value={searchQuery}
// // //             onChange={handleSearchChange}
// // //           />

// // //           <button
// // //             className={`btn ${isHovered ? 'btn-light text-success' : 'btn-success text-white'} d-flex align-items-center justify-content-center`}
// // //             type="submit"
// // //             onMouseEnter={() => setIsHovered(true)}
// // //             onMouseLeave={() => setIsHovered(false)}
// // //             style={{ minWidth: '120px', height: '50px' }}
// // //           >
// // //             {!isHovered ? (
// // //               <span>Search</span>
// // //             ) : (
// // //               <Lottie options={defaultOptions} height={40} width={80} />
// // //             )}
// // //           </button>
// // //         </form>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // export default Home;


// // import React, { useState, useEffect } from 'react';
// // import { Outlet, useNavigate } from 'react-router-dom';
// // import { faHandPaper } from '@fortawesome/free-solid-svg-icons'; 
// // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// // import animationData from '../../../src/animations/search.json';
// // import Lottie from 'react-lottie';
// // import { useSelector } from 'react-redux';
// // import 'bootstrap/dist/css/bootstrap.min.css';
// // import './Home.css';

// // const text = 'Project Hub';

// // const LetterRotator = () => {
// //   return (
// //     <div className="textr d-flex flex-wrap justify-content-center mb-3" style={{ fontSize: '7vw', fontWeight: 'bold', color: '#1C1F4C' }}>
// //       {text.split('').map((letter, index) => (
// //         <span key={index} className="mx-0">{letter}</span>
// //       ))}
// //     </div>
// //   );
// // };

// // function Home() {
// //   const [isHovered, setIsHovered] = useState(false);
// //   const [searchQuery, setSearchQuery] = useState('');
// //   const [showGreeting, setShowGreeting] = useState(true);
// //   const [greetingAnimation, setGreetingAnimation] = useState('slideIn');
// //   const navigate = useNavigate();

// //   const defaultOptions = {
// //     loop: true,
// //     autoplay: true,
// //     animationData: animationData,
// //     rendererSettings: {
// //       preserveAspectRatio: 'xMidYMid slice',
// //     },
// //   };

// //   const user = useSelector((state) => state.User.currentUser);
// //   const login = !!user;

// //   useEffect(() => {
// //     const timer = setTimeout(() => {
// //       setGreetingAnimation('slideOut');
// //     }, 1000);

// //     const hideTimer = setTimeout(() => {
// //       setShowGreeting(false);
// //     }, 2000);

// //     return () => {
// //       clearTimeout(timer);
// //       clearTimeout(hideTimer);
// //     };
// //   }, []);

// //   const handleSearchChange = (event) => {
// //     setSearchQuery(event.target.value);
// //   };

// //   const handleSearchSubmit = (event) => {
// //     event.preventDefault();
// //     navigate(`/projects?query=${encodeURIComponent(searchQuery)}`);
// //   };

// //   return (

      
// //     <div className="container-fluid min-vh-100 d-flex flex-column justify-content-center align-items-center bg-light text-center px-3" 
// //          style={{ background: 'linear-gradient(155deg, #ffffff 50%, #ebecff 50%)' }}>
         
// //       <div className="position-relative w-100">
// //         {login && user?.name && showGreeting && (
// //           <div className="position-fixed end-0 p-3" style={{ top: '70px', zIndex: 1050, animation: `${greetingAnimation} 1s ease-in-out` }}>
// //             <div className="bg-warning text-dark rounded px-3 py-1 shadow">
// //               <FontAwesomeIcon icon={faHandPaper} className="me-2" />
// //               Hi, {user.name}
// //             </div>
// //           </div>
// //         )}

// //         <div className="mt-5">
// //           <Outlet />
// //           <h6 className="text-college" style={{ fontWeight: '600', color: '#037272' }}>VNRVJIET</h6>
// //         </div>

// //         <LetterRotator />

// //         <p className="lead" style={{ fontWeight: '600', color: '#037272' }}>Find, Learn, and Inspire with College Projects</p>

// //         <form 
// //           className="home-search-form w-50 w-sm-75 mx-auto d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 px-2" 
// //           onSubmit={handleSearchSubmit}
// //         >
// //           <input
// //             className="form-control home-search-input flex-grow-1"
// //             type="search"
// //             placeholder="Search..."
// //             aria-label="Search"
// //             value={searchQuery}
// //             onChange={handleSearchChange}
// //           />

// //           <button
// //             className={`btn ${isHovered ? 'btn-light text-success' : 'btn-success text-white'} d-flex align-items-center justify-content-center`}
// //             type="submit"
// //             onMouseEnter={() => setIsHovered(true)}
// //             onMouseLeave={() => setIsHovered(false)}
// //             style={{ minWidth: '120px', height: '50px' }}
// //           >
// //             {!isHovered ? (
// //               <span>Search</span>
// //             ) : (
// //               <Lottie options={defaultOptions} height={40} width={80} />
// //            )}
// //           </button>
// //         </form>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Home;


// import React, { useState, useEffect } from 'react';
// import { Outlet, useNavigate } from 'react-router-dom';
// import { faHandPaper } from '@fortawesome/free-solid-svg-icons'; 
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import animationData from '../../../src/animations/search.json';
// import Lottie from 'react-lottie';
// import { useSelector } from 'react-redux';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './Home.css';

// const text = 'Project Hub';

// const LetterRotator = () => {
//   return (
//     <div className="textr d-flex flex-wrap justify-content-center mb-3" style={{ fontSize: '7vw', fontWeight: 'bold', color: '#1C1F4C' }}>
//       {text.split('').map((letter, index) => (
//         <span key={index} className="mx-0">{letter}</span>
//       ))}
//     </div>
//   );
// };

// function Home() {
//   const [isHovered, setIsHovered] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [showGreeting, setShowGreeting] = useState(true);
//   const [greetingAnimation, setGreetingAnimation] = useState('slideIn');
//   const navigate = useNavigate();

//   const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: animationData,
//     rendererSettings: {
//       preserveAspectRatio: 'xMidYMid slice',
//     },
//   };

//   const user = useSelector((state) => state.User.currentUser);
//   const login = !!user;

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setGreetingAnimation('slideOut');
//     }, 1000);

//     const hideTimer = setTimeout(() => {
//       setShowGreeting(false);
//     }, 2000);

//     return () => {
//       clearTimeout(timer);
//       clearTimeout(hideTimer);
//     };
//   }, []);

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   const handleSearchSubmit = (event) => {
//     event.preventDefault();
//     navigate(`/projects?query=${encodeURIComponent(searchQuery)}`);
//   };

//   return (
//     <div className="container-fluid min-vh-100 d-flex flex-column justify-content-center align-items-center bg-light text-center px-3" 
//          style={{ background: 'linear-gradient(155deg, #ffffff 50%, #ebecff 50%)' }}>
         
//     {/* 🟢 Light Green Scrolling Banner - Positioned at top: 4px */}
// <div 
//   className="w-100 bg-success bg-opacity-25 text-dark py-2 position-fixed start-0" 
//   style={{ top: '64.2px', zIndex: 1100 }}
// >
//   <div className="scrolling-text-container">
//     <p className="mb-0 fw-semibold d-flex align-items-center gap-2 justify-content-center">
//       <span>Hey 2025 Batch! Let your minor projects shine too — showcase them on Project Hub!</span>
//       <a 
//         href="https://docs.google.com/forms/d/e/1FAIpQLSdnzGg9FfuqQq8T0aE2fepNyXytDEVfIzbOn3E7wf3fbvgZxg/viewform?usp=header" 
//         target="_blank" 
//         rel="noopener noreferrer" 
//         className="text-success text-decoration-underline fw-bold"
//       >
//         Click here to add
//       </a>
//     </p>
//   </div>
// </div>
//       <div className="position-relative w-100">
//         {login && user?.name && showGreeting && (
//           <div className="position-fixed end-0 p-3" style={{ top: '70px', zIndex: 1050, animation: `${greetingAnimation} 1s ease-in-out` }}>
//             <div className="bg-warning text-dark rounded px-3 py-1 shadow">
//               <FontAwesomeIcon icon={faHandPaper} className="me-2" />
//               Hi, {user.name}
//             </div>
//           </div>
//         )}

//         <div className="mt-5">
//           <Outlet />
//           <h6 className="text-college" style={{ fontWeight: '600', color: '#037272' }}>VNRVJIET</h6>
//         </div>

//         <LetterRotator />

//         <p className="lead" style={{ fontWeight: '600', color: '#037272' }}>Find, Learn, and Inspire with College Projects</p>

//         <form 
//           className="home-search-form w-50 w-sm-75 mx-auto d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 px-2" 
//           onSubmit={handleSearchSubmit}
//         >
//           <input
//             className="form-control home-search-input flex-grow-1"
//             type="search"
//             placeholder="Enter the title of the project"
//             aria-label="Search"
//             value={searchQuery}
//             onChange={handleSearchChange}
//           />

//           <button
//             className={`btn ${isHovered ? 'btn-light text-success' : 'btn-success text-white'} d-flex align-items-center justify-content-center`}
//             type="submit"
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//             style={{ minWidth: '120px', height: '50px' }}
//           >
//             {!isHovered ? (
//               <span>Search</span>
//             ) : (
//               <Lottie options={defaultOptions} height={40} width={80} />
//            )}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default Home;


import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { faHandPaper } from '@fortawesome/free-solid-svg-icons'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import animationData from '../../../src/animations/search.json';
import Lottie from 'react-lottie';
import { useSelector } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css';

const text = 'Project Hub';

const LetterRotator = () => {
  return (
    <div className="textr d-flex flex-wrap justify-content-center mb-3" 
         style={{ fontSize: '7vw', fontWeight: 'bold', color: '#1C1F4C' }}>
      {text.split('').map((letter, index) => (
        <span key={index} className="mx-0">{letter}</span>
      ))}
    </div>
  );
};

function Home() {
  const [isHovered, setIsHovered] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showGreeting, setShowGreeting] = useState(true);
  const [greetingAnimation, setGreetingAnimation] = useState('slideIn');
  const navigate = useNavigate();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const user = useSelector((state) => state.User.currentUser);
  const login = !!user;

  useEffect(() => {
    const timer = setTimeout(() => setGreetingAnimation('slideOut'), 1000);
    const hideTimer = setTimeout(() => setShowGreeting(false), 2000);

    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  const handleSearchChange = (event) => setSearchQuery(event.target.value);

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    navigate(`/projects?query=${encodeURIComponent(searchQuery)}`);
  };

  return (
    <div className="container-fluid min-vh-100 d-flex flex-column align-items-center bg-light text-center px-3" 
         style={{ background: 'linear-gradient(155deg, #ffffff 50%, #ebecff 50%)' }}>

      {/* 🟢 Scrolling Banner */}
      <div className="w-100 bg-success bg-opacity-25 text-dark py-2 scrolling-banner" style={{ zIndex: 1100 }}>
        <p className="mb-0 fw-semibold scrolling-text">
          Hey 2025 Batch! Let your minor projects shine too — showcase them on Project Hub! 
          <a 
            href="https://docs.google.com/forms/d/e/1FAIpQLSdnzGg9FfuqQq8T0aE2fepNyXytDEVfIzbOn3E7wf3fbvgZxg/viewform?usp=header" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-success text-decoration-underline fw-bold"
          >
            Click here to add
          </a>
        </p>
      </div>

      {/* Greeting for logged-in user */}
      {login && user?.name && showGreeting && (
        <div className="position-fixed end-0 p-3" 
             style={{ top: '70px', zIndex: 1050, animation: `${greetingAnimation} 1s ease-in-out` }}>
          <div className="bg-warning text-dark rounded px-3 py-1 shadow">
            <FontAwesomeIcon icon={faHandPaper} className="me-2" />
            Hi, {user.name}
          </div>
        </div>
      )}

      {/* Main content */}
      <div className="mt-4 w-100">
        <Outlet />
        <h6 className="text-college" style={{ fontWeight: '600', color: '#037272' }}>VNRVJIET</h6>
      </div>

      {/* Rotating title */}
      <LetterRotator />

      <p className="lead" style={{ fontWeight: '600', color: '#037272' }}>
        Find, Learn, and Inspire with College Projects
      </p>

      {/* Search Form */}
      <form 
        className="home-search-form w-50 w-sm-75 mx-auto d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 px-2 mb-4" 
        onSubmit={handleSearchSubmit}
      >
        <input
          className="form-control home-search-input flex-grow-1"
          type="search"
          placeholder="Enter the title of the project"
          aria-label="Search"
          value={searchQuery}
          onChange={handleSearchChange}
        />

        <button
          className={`btn ${isHovered ? 'btn-light text-success' : 'btn-success text-white'} d-flex align-items-center justify-content-center`}
          type="submit"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{ minWidth: '120px', height: '50px' }}
        >
          {!isHovered ? (
            <span>Search</span>
          ) : (
            <Lottie options={defaultOptions} height={40} width={80} />
         )}
        </button>
      </form>
    </div>
  );
}

export default Home;
